import { BaseApi } from '@shared/config';
import type {
  AIConstant,
  AIConstantsResponse,
  AIConstantUpdateRequest,
  GetAIConstantsParams,
} from './types';

export class AIConstantsApi extends BaseApi {
  getAIConstants = (
    params: GetAIConstantsParams
  ): Promise<AIConstantsResponse> => {
    return this.instance.get('admin/ai-constants', { params });
  };

  getAiConstant = (id: number): Promise<AIConstant> => {
    return this.instance.get(`admin/ai-constants/${id}`);
  };

  updateAiConstant = (
    id: number,
    data: AIConstantUpdateRequest
  ): Promise<AIConstant> => {
    return this.instance.put(`admin/ai-constants/${id}`, data);
  };
}

export const aiConstantsApi = new AIConstantsApi();
